import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import {request, handleRequestErrors} from '../../helpers/Requests'

class Locations extends Component {
  render() {
    const { locations, loaded, error, unauthorized } = this.state;

    if (unauthorized) {
      return <Redirect to="/login"/> 
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (loaded === false) {
      return <p>Loading ...</p>;
    }

    if (loaded) {
      return (
        <div className="widget" style={{fontSize: "17px"}}>
          <div className="table big-table">
            <div className="tr heading">
              <div className="th">Name</div>
              <div className="th">Number of Devices</div>
              <div className="th">Last Contacted</div>
            </div>
            {locations.map((location) => (
              <Link to={`/location/${location.id}`} key={location.id} className="tr">
                <div className="td">{location.name}</div>
                <div className="td">{location.number_of_devices}</div>
                <div className="td">{location.last_contacted}</div>
              </Link>
            ))}
          </div>
        </div>
      );
    }
  }

  state = {
    locations: [],
    loaded: false,
    error: null
  };

  componentDidMount() {
    request("GET", `/v1/a/organisations/0/locations`, "", () => {this.setState({unauthorized: true})})
      .then(data => this.setState({ locations: data, loaded: true }))
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }
}

export default Locations;